import clsx from 'clsx';
import { LoaderSpinnerSizes } from 'carbon-react/lib/components/loader-spinner/loader-spinner.config';
import React, { FC } from 'react';

import * as styles from './ui-loader.scss';
import { UILoaderSpinner } from './ui-loader-spinner';

export interface UILoaderProps {
  isFull?: boolean;
  style?: React.CSSProperties;
  label?: string;
  size?: LoaderSpinnerSizes;
}

export const UILoader: FC<UILoaderProps> = props => {
  const { style, isFull = false, label, size } = props;

  return (
    <div className={clsx(styles.loaderContainer, { [styles.loaderFull]: isFull })} style={style}>
      <UILoaderSpinner label={label} size={size} />
    </div>
  );
};
